"use client";
import CustomInput from "@/components/shared/CustomInput";
import CustomSelect from "@/components/shared/CustomSelect";
import React, { useState } from "react";
import uploadImage2 from "@/public/images/uploadImage2.svg";
import Image from "next/image";
import uploadImage from "@/public/images/uploadImage.svg";
import upload1 from "@/public/images/upload1.svg";
import upload2 from "@/public/images/upload2.svg";
import { ErrorMessage, Field } from "formik";
import { handleKeyDownNumber } from "@/lib/utils";
const index = ({ formikProps }: { formikProps: any }) => {
  const [Images, setImages] = useState<
    { file: File | undefined; url: string | undefined | any }[]
  >([{ file: undefined, url: undefined }]);
  const [SelectedImage, setImage] = useState({ file: "", url: "" });
  return (
    <div className="flex flex-col lg:flex-row  gap-5">
      <div
        className={` relative w-full lg:w-[300px] h-[215px] rounded-[10px] ${
          formikProps.errors.profileImage && "border border-red-500"
        }`}
      >
        <Field
          type="file"
          name="profileImage"
          label="صورة البروفيل"
          accept=".png, .jpg, .jpeg"
          className=" w-full h-full absolute inset-0  cursor-pointer opacity-0 bg-red-500 z-20"
          value={undefined}
          onChange={(e: any) => {
            formikProps.setFieldValue("profileImage", e.target.files[0]);
            setImage({
              file: e.target.files[0],
              url: URL.createObjectURL(e.target.files[0]),
            });
          }}
        />
        <div className=" flex items-center justify-center flex-col gap-5 w-full h-full bg-[#323538] p-5 rounded-[10px]">
          <Image
            src={SelectedImage.url !== "" ? SelectedImage.url : upload1}
            alt="upload1"
            width={75}
            height={75}
            className=" rounded-full w-[75px] h-[75px] object-cover"
          />
          <Image src={upload2} alt="upload1" />
          <p className=" text-[10px] text-textColor text-center max-w-[250px]">
            تذكر: للحصول على أفضل النتائج، استخدم صورة بحجم 200 × 200 بكسل على
            الأقل بتنسيق .jpg أو .png
          </p>
        </div>
        {/* <Image
          src={SelectedImage.url !== "" ? SelectedImage.url : uploadImage}
          alt="uploadImage"
          fill
          sizes="100vw"
          className=" rounded-[10px]  object-cover "
        /> */}
        <ErrorMessage
          name="profileImage"
          component="div"
          className="text-[#F75555]"
        />
      </div>
      <div className=" flex flex-col gap-5 grow">
        <CustomInput
          type="text"
          name="phone"
          placeholder="رقم هاتفك"
          label="رقم هاتفك"
          FormikProps={formikProps}
          required={true}
          onKeyDown={handleKeyDownNumber}
        />
        <div className=" grid grid-cols-1 md:grid-cols-2 gap-5 ">
          {/* <CustomInput
            type="text"
            name="userName"
            label=" اسم المستخدم ( اليوزر نيم ) "
            placeholder=" اسم المستخدم ( اليوزر نيم ) "
            FormikProps={formikProps}
            required={true}
          /> */}
          {/* <CustomInput
            type="email"
            name="email"
            placeholder="البريد الالكتروني"
            label="البريد الالكتروني"
            FormikProps={formikProps}
            required={true}
          /> */}
          <CustomInput
            type="text"
            name="password"
            placeholder="كلمة المرور"
            label="كلمة المرور"
            FormikProps={formikProps}
            required={true}
            eye={true}
          />
          <CustomInput
            type="text"
            name="confirmPassword"
            placeholder="تأكيد كلمة المرور"
            label="تأكيد كلمة المرور"
            FormikProps={formikProps}
            required={true}
            eye={true}
          />
        </div>
        {/* <div className=" grid grid-cols-1 lg:grid-cols-2  gap-5 ">
          <CustomInput
            type="text"
            name="fatherName"
            placeholder="اسم ولي الامر"
          />
          <CustomInput
            type="text"
            name="fatherPhone"
            placeholder="رقم ولي الامر"
          />
        </div>
        <div className=" grid grid-cols-1 lg:grid-cols-2  gap-5 ">
          <CustomSelect
            name="city"
            placeholder="المدينة"
            data={[{ id: 1, name: "test" }]}
            FormikProps={formikProps}
          />
          <CustomSelect
            name="country"
            placeholder="المحافظة"
            data={[{ id: 1, name: "test" }]}
            FormikProps={formikProps}
          />
        </div>
        <div className=" grid grid-cols-1 lg:grid-cols-2  gap-5 ">
          <CustomSelect
            name="gender"
            placeholder="الجنس"
            data={[{ id: 1, name: "test" }]}
            FormikProps={formikProps}
          />
        </div> */}
      </div>
    </div>
    // <div>
    //   <CustomInput type="email" name="email" placeholder="البريد الالكتروني" />
    //   <div className=" grid grid-cols-1 md:grid-cols-2  gap-5 my-5">
    //     <CustomInput type="text" name="password" placeholder="كلمة المرور" />
    //     <CustomInput
    //       type="text"
    //       name="confirmPassword"
    //       placeholder="تأكيد كلمة المرور"
    //     />
    //   </div>
    //   <div className="bg-[#474A4D] rounded-[10px] p-5 flex flex-col-reverse md:flex-row  justify-between gap-5">
    //     <div>
    //       <p className=" text-18 text-white fonr-[600]">
    //         ارافق صوره للبطاقه وش وظهر
    //       </p>
    //       <p className=" text-16 text-textColor">
    //         هذا النص وهوا مولد للنص العربي يمكن استبدالة هنا
    //       </p>
    //       <div className=" mt-5 flex flex-wrap gap-5">
    //         {Images[0].url !== undefined &&
    //           Images.map((image, index) => (
    //             <Image
    //               src={image.url}
    //               alt="uploadImage2"
    //               key={index}
    //               width={150}
    //               height={150}
    //             />
    //           ))}
    //       </div>
    //     </div>
    //     <div className=" relative">
    //       <Field
    //         type="file"
    //         name="identificaionCard"
    //         className=" w-full h-full absolute inset-0 bg-red-500 cursor-pointer opacity-0 "
    //         value={undefined}
    //         multiple
    //         onChange={(e: any) => {
    //
    //
    //           setImages([]);
    //           // Get the selected files
    //           const selectedFiles = Array.from(e.target.files);

    //           // Create an array to store information about each selected image
    //           const newImages = selectedFiles.map((file: any) => ({
    //             file: file,
    //             url: URL.createObjectURL(file),
    //           }));

    //           // Update the state with the new array of images
    //           setImages((prevImages) => [...prevImages, ...newImages]);
    //           formikProps.setFieldValue("identificaionCard", Images);
    //
    //         }}
    //       />
    //       <Image src={uploadImage2} alt="uploadImage2" />
    //     </div>
    //   </div>
    // </div>
  );
};

export default index;
